{
  "name": "simple-savings-guide",
  "version": "3.3.5-develop.0",
  "scripts": {
    "watch": "ng test",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost-internal.sparbanken.me",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test --watch=false --code-coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.12",
    "@angular/common": "^21.2.12",
    "@angular/compiler": "^21.2.12",
    "@angular/core": "^21.2.12",
    "@angular/forms": "^21.2.12",
    "@angular/platform-browser": "^21.2.12",
    "@angular/platform-browser-dynamic": "^21.2.12",
    "@angular/router": "^21.2.12",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/core": "^21.2.10",
    "@angular-devkit/schematics": "^21.2.10",
    "@angular/build": "^21.2.10",
    "@angular/cdk": "^21.2.10",
    "@angular/cli": "^21.2.10",
    "@angular/compiler-cli": "^21.2.12",
    "@angular/material": "^21.2.10",
    "@sparbanken-syd/abasec": "^4.2.1",
    "@sparbanken-syd/auth-backend": "^2.6.3",
    "@sparbanken-syd/document-service": "^2.5.1",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/simple-savings-guide-be": "^3.4.0",
    "@sparbanken-syd/sparbanken-syd-bankid": "^21.2.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^21.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^21.2.1",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^21.1.1",
    "@sparbanken-syd/teradata-user": "^3.5.0",
    "@types/jasmine": "^6.0.0",
    "@types/sinon": "^21.0.1",
    "angular-eslint": "^21.3.1",
    "baseline-browser-mapping": "^2.10.29",
    "eslint": "^9.28.0",
    "jasmine-core": "^6.2.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "ngx-extended-pdf-viewer": "^25.6.4",
    "postcss": "^8.5.14",
    "puppeteer": "^24.43.1",
    "stylelint": "^17.11.0",
    "stylelint-config-sass-guidelines": "^13.0.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.1.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.59.2"
  }
}
